export const connectGrades = {
  PK: { label: "PK" },
  KG: { label: "K" },
  "1": { label: "1st" },
  "2": { label: "2nd" },
  "3": { label: "3rd" },
  "4": { label: "4th" },
  "5": { label: "5th" },
  "6": { label: "6th" },
  "7": { label: "7th" },
  "8": { label: "8th" },
  "9": { label: "9th" },
  "10": { label: "10th" },
  "11": { label: "11th" },
  "12": { label: "12th" },
} as const;

export type GradeKey = keyof typeof connectGrades;

export const connectGradeOrder: [GradeKey, ...GradeKey[]] = [
  "PK",
  "KG",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
];

export const sortGradesByOrder = (grades: readonly string[]): GradeKey[] =>
  grades
    .filter((grade): grade is GradeKey => grade in connectGrades)
    .sort(
      (a, b) => connectGradeOrder.indexOf(a) - connectGradeOrder.indexOf(b),
    );

export const connectGradeBands = [
  { label: "Elementary", grades: ["PK", "KG", "1", "2", "3", "4", "5"] },
  { label: "Middle", grades: ["6", "7", "8"] },
  { label: "High", grades: ["9", "10", "11", "12"] },
] as const satisfies readonly { label: string; grades: readonly GradeKey[] }[];

export type GradeBand = (typeof connectGradeBands)[number];
